import { toast } from 'react-toastify';
import { browserHistory } from 'react-router';

import AuthApi from '../../../../api/auth-api';
import UserProfileApi from '../../../../api/user-profile-api';
import { handleHttpInProgress } from '../../../shared/http-in-progress/actions/http-in-progress-actions';
import loginActionTypes from '../constants/action-types';
import CookiesWrapper from '../../../../common/cookies-wrapper';
import constants from '../../../../common/constants';
import { handleSuccessGetUserProfile } from '../../user-profile/actions/user-profile-actions';

export const handleLoginError = error => {
  return {
    type: loginActionTypes.HANDLE_LOGIN_ERROR,
    data: error,
  };
};

export const login = (username, password) => {
  return async dispatch => {
    try {
      dispatch(handleHttpInProgress(true));
      const response = await AuthApi.login(username, password);
      const token = response.headers['x-token'];
      const xsrf = response.headers['x-xsrf-token'];
      const profileResponse = await UserProfileApi.getUserProfile(token, xsrf);
      const profile = profileResponse && profileResponse.data && profileResponse.data[0];
      CookiesWrapper.setCookie(constants.cookie_key_word, {
        token,
        xsrf,
        user_name: profile.user_name,
        user_bo_status: profile.bo_status,
        user_type: profile.user_type,
      });
      dispatch(handleSuccessGetUserProfile(profile));
      dispatch(handleHttpInProgress(false));
      browserHistory.push('/app/dashboard');
    } catch (error) {
      dispatch(handleHttpInProgress(false));
      if (error && error.response && error.response.status === 401) {
        dispatch(handleLoginError('LOGIN.WRONG_CREDENTIALS'));
      } else {
        toast.error('Something went wrong please contact our support.');
      }
    }
  };
};



// WEBPACK FOOTER //
// ./src/app/main/login/actions/login-actions.js